var s2 = "/static/ac05316edeb3cf32.png";

export { s2 as default };
//# sourceMappingURL=s_2.png.js.map
